// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__RUeg7","space":"style_space__XBmsz"};